module.exports = __webpack_public_path__ + "static/media/cidekic_logo_bw.b27cc461.svg";